{
	"name": "radianui",
	"description": "Add components to your project",
	"version": "0.2.1",
	"main": "index.js",
	"type": "module",
	"publishConfig": {
		"access": "public"
	},
	"exports": "./dist/index.js",
	"bin": {
		"radianui": "dist/index.js"
	},
	"files": [
		"dist",
		"README.md",
		"package.json"
	],
	"scripts": {
		"dev": "tsup --watch && tsup",
		"build": "tsup",
		"release": "changeset version",
		"pre:enter": "changeset pre enter alpha",
		"pre:exit": "changeset pre exit",
		"pub:alpha": "pnpm build && pnpm publish --no-git-checks --access public --tag alpha",
		"pub:next": "pnpm build && pnpm publish --no-git-checks --access public --tag next",
		"pub:release": "pnpm build && pnpm publish --no-git-checks --access public",
		"unit": "vitest run unit",
		"e2e": "vitest run cli",
		"test": "vitest run",
		"update-snapshot": "vitest -u",
		"coverage": "vitest run --coverage"
	},
	"keywords": [
		"radian",
		"radianos",
		"radianos cli",
		"components",
		"ui",
		"tailwind",
		"radix-ui"
	],
	"author": "RadianOS <radianos44@gmail.com> (https://radianos.com)",
	"license": "MIT",
	"repository": {
		"type": "git",
		"url": "https://github.com/Radian-os/radianos"
	},
	"homepage": "https://github.com/Radian-os/radianos#readme",
	"dependencies": {
		"@clack/prompts": "^0.11.0",
		"adm-zip": "^0.5.16",
		"chalk": "^5.6.2",
		"commander": "^14.0.2",
		"cosmiconfig": "^9.0.0",
		"execa": "^9.6.0",
		"fast-glob": "^3.3.3",
		"fs-extra": "^11.3.2",
		"gradient-string": "^3.0.0",
		"json5": "^2.2.3",
		"node-fetch": "^3.3.2",
		"ora": "^9.0.0",
		"package-manager-detector": "^1.5.0",
		"postcss": "^8.5.6",
		"prompts": "^2.4.2",
		"ts-morph": "^27.0.2",
		"tsconfig-paths": "^4.2.0",
		"tsup": "^8.5.0",
		"type-fest": "^5.1.0",
		"zod": "^4.1.12"
	},
	"devDependencies": {
		"@types/adm-zip": "^0.5.7",
		"@types/fs-extra": "^11.0.4",
		"@types/node": "^24.9.2",
		"@types/prompts": "^2.4.9",
		"@vitest/coverage-istanbul": "^4.0.4",
		"cross-env": "^7.0.3",
		"typescript": "^5.9.3",
		"vite-tsconfig-paths": "^5.1.4",
		"vitest": "^4.0.4"
	}
}
